var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquaredMeter = function SvgSquaredMeter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "squared_meter_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#646363",
    mask: "url(#squared_meter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 7.333V8.5a.485.485 0 0 0 .5.5h2q.2 0 .35-.142T21 8.5a.48.48 0 0 0-.15-.35.48.48 0 0 0-.35-.15H19v-.667h1.333a.65.65 0 0 0 .475-.191.65.65 0 0 0 .192-.475v-1a.65.65 0 0 0-.192-.475.65.65 0 0 0-.475-.192H18.5a.47.47 0 0 0-.358.15.5.5 0 0 0-.142.35.485.485 0 0 0 .483.5H20v.667h-1.333a.65.65 0 0 0-.475.191.65.65 0 0 0-.192.475M5 18V8.267q0-.534.367-.9.366-.367.9-.367h.566q.4 0 .725.217.325.216.459.6L11 15.7l2.933-7.817q.15-.4.5-.641.35-.242.784-.242h.416q.567 0 .967.4t.4.967V18a.96.96 0 0 1-.292.708A.96.96 0 0 1 16 19a.96.96 0 0 1-.708-.292A.96.96 0 0 1 15 18v-7.167l-2.95 7.65a.76.76 0 0 1-.283.375.76.76 0 0 1-.45.142h-.634a.76.76 0 0 1-.45-.142.76.76 0 0 1-.283-.375L7 10.883V18a.96.96 0 0 1-.292.708A.96.96 0 0 1 6 19a.96.96 0 0 1-.708-.292A.96.96 0 0 1 5 18"
  }))));
};
export default SvgSquaredMeter;